import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { scrollToTop } from '#/utils/scroll';

import { parseStepSearchParam } from './multiStepSearchParams';

export const useMultiStep = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentStep = useMemo(
    () => parseStepSearchParam(searchParams.get('step')),
    [searchParams],
  );

  const navigateToStep = useCallback(
    (step: number | ((prevStep: number) => number)) => {
      scrollToTop();
      window.setTimeout(() => {
        const newStep = typeof step === 'function' ? step(currentStep) : step;
        setSearchParams({ step: newStep.toString() });
      }, 10);
    },
    [setSearchParams, currentStep],
  );

  return { navigateToStep, currentStep };
};
